import { apiRequest } from '../api/client';

export interface TotpEnrollment {
  secret: string;
  /** otpauth:// URI, which is what the QR code encodes. */
  enrollmentUri: string;
}

/** Matches `apps/api` `POST /auth/totp/enroll`. */
export function startTotpEnrollment(): Promise<TotpEnrollment> {
  return apiRequest<TotpEnrollment>('/auth/totp/enroll', {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

/** Matches `apps/api` `POST /auth/totp/confirm`. */
export function confirmTotpEnrollment(code: string): Promise<void> {
  return apiRequest<void>('/auth/totp/confirm', {
    method: 'POST',
    body: JSON.stringify({ code }),
  });
}
